/* Sultan Noten — collection sidebar (sections/main-collection-product-grid.liquid)
   1. "Search within this collection" (#SnCollSearch)
   2. Extra filter groups — Kategori, Ağırlık / Paket, Marka, Öne Çıkanlar — built from
      the tags, the "Seçenek" option and the vendor of the products (snippets/sn-custom-filters.liquid)
   Both work on the product cards of the grid. As soon as one of them is used on a collection
   with more than one page, the other pages are fetched once and their cards join the grid,
   so the result always covers the whole collection. */
(function () {
  var cfgEl = document.getElementById('SnCollConfig');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = cfg.t;
  var input = document.getElementById('SnCollSearch');
  var hosts = cfg.filters ? [].slice.call(document.querySelectorAll('[data-sn-cf-groups]')) : [];

  var norm = function (s) {
    return String(s || '')
      .toLocaleLowerCase('tr')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ı/g, 'i')
      .trim();
  };
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  };

  /* ---------- the groups and their values ---------- */

  /* section setting lines: "Tag, other tag = Turkish name | Dutch name | English name" */
  var langIdx = { nl: 1, en: 2 }[cfg.lang] || 0;
  function parseList(text) {
    return String(text || '').split(/\r?\n/).map(function (line) {
      var eq = line.indexOf('=');
      var tags = (eq < 0 ? line : line.slice(0, eq)).split(',').map(norm).filter(Boolean);
      var names = (eq < 0 ? line : line.slice(eq + 1)).split('|').map(function (s) { return s.trim(); });
      return tags.length ? { key: tags[0], tags: tags, label: names[langIdx] || names[0] } : null;
    }).filter(Boolean);
  }
  var CATS = parseList(cfg.categories);
  var FEATS = [{ key: '#sale', tags: [], label: T.sale }].concat(parseList(cfg.features));
  var GROUPS = [
    { id: 'cat', label: T.cat },
    { id: 'pack', label: T.pack },
    { id: 'brand', label: T.brand },
    { id: 'feat', label: T.feat }
  ];

  /* label and sort position of every value, per group */
  var info = { cat: {}, pack: {}, brand: {}, feat: {} };
  CATS.forEach(function (c, i) { info.cat[c.key] = { label: c.label, sort: i }; });
  FEATS.forEach(function (f, i) { info.feat[f.key] = { label: f.label, sort: i }; });

  /* Weight, volume or number of pieces from a "Seçenek" value, as one clean value:
     "400gr" / "400 gram" → "400 gram", "1kg" / "1 kilo" / "1000 gram" → "1 kg", "32li" → "32 Adet".
     Anything else ("Juf", "1 alana 1 bedava", …) is not a size and stays out of the filter. */
  function pack(value) {
    var s = String(value).trim().replace(/\s+/g, ' ');
    var num = function (x) { return String(x).replace('.', ','); };
    var m = s.match(/^(\d+(?:[.,]\d+)?) ?(g|gr|gram|grams|kg|kilo|kilogram|ml|l|lt|litre|liter)\.?$/i);
    if (m) {
      var n = parseFloat(m[1].replace(',', '.'));
      var unit = m[2].toLowerCase();
      if (/^(kg|kilo|kilogram)$/.test(unit)) n *= 1000;
      if (/^(g|gr|gram|grams|kg|kilo|kilogram)$/.test(unit)) {
        n = Math.round(n);
        return { key: n + 'g', label: n >= 1000 ? num(n / 1000) + ' kg' : n + ' gram', sort: n };
      }
      if (/^(l|lt|litre|liter)$/.test(unit)) n *= 1000;
      n = Math.round(n);
      return { key: n + 'ml', label: n >= 1000 ? num(n / 1000) + ' L' : n + ' ml', sort: 1e6 + n };
    }
    m = s.match(/^(\d+)(?: ?[-/] ?(\d+))? ?(adet|'?l[ıiuü]|bağ|bag)$/i);
    if (m) {
      var a = parseInt(m[1], 10);
      var b = m[2] ? parseInt(m[2], 10) : 0;
      var bundle = /^ba[gğ]$/i.test(m[3]);
      var word = bundle ? ' Bağ' : ' Adet';
      var id = (b ? a + '-' + b : a) + (bundle ? 'bag' : 'pc');
      return { key: id, label: (b ? a + '–' + b : a) + word, sort: (bundle ? 3e6 : 2e6) + a };
    }
    return null;
  }

  /* one product card + the values it has in every group */
  function record(p, el, page) {
    var tags = (p.tags || []).map(norm);
    var has = function (list) { return list.some(function (t) { return tags.indexOf(t) !== -1; }); };
    var title = el.querySelector('.product-item__title');
    var r = { el: el, page: page, title: norm(title ? title.textContent : el.textContent), v: {} };
    r.v.cat = CATS.filter(function (c) { return has(c.tags); }).map(function (c) { return c.key; });
    r.v.feat = FEATS.filter(function (f) { return f.key === '#sale' ? p.sale : has(f.tags); }).map(function (f) { return f.key; });
    r.v.pack = [];
    (p.opts || []).forEach(function (o) {
      var w = o && pack(o);
      if (!w) return;
      if (!info.pack[w.key]) info.pack[w.key] = { label: w.label, sort: w.sort };
      if (r.v.pack.indexOf(w.key) === -1) r.v.pack.push(w.key);
    });
    r.v.brand = [];
    if (p.vendor) {
      var b = norm(p.vendor);
      if (!info.brand[b]) info.brand[b] = { label: p.vendor, sort: 0 };
      r.v.brand.push(b);
    }
    return r;
  }

  function readGrid(g, page) {
    var byId = {};
    var dataEl = g.querySelector('[data-sn-cf-data]');
    if (dataEl) {
      try { JSON.parse(dataEl.textContent).forEach(function (p) { byId[p.id] = p; }); } catch (e) {}
    }
    return [].slice.call(g.querySelectorAll('.product-item')).map(function (el) {
      return record(byId[el.id.replace('product-item-', '')] || {}, el, page);
    });
  }

  /* ---------- the grid: this page, and the other pages once they are needed ---------- */

  var grid, pager, pages, page, items, extra, loaded, loading, expanded;

  function init() {
    grid = document.getElementById('main-collection-product-grid');
    if (!grid) return false;
    var dataEl = grid.querySelector('[data-sn-cf-data]');
    pages = dataEl ? parseInt(dataEl.getAttribute('data-pages'), 10) || 1 : 1;
    page = dataEl ? parseInt(dataEl.getAttribute('data-page'), 10) || 1 : 1;
    var nav = grid.querySelector('.pagination');
    pager = nav && nav.closest('nav') ? nav.closest('nav').parentNode : null;
    items = readGrid(grid, page);
    extra = null;
    loaded = pages <= 1;
    loading = null;
    expanded = false;
    return true;
  }

  function loadAll() {
    if (loaded) return Promise.resolve();
    if (loading) return loading;
    var gridAtStart = grid;
    var params = new URLSearchParams(location.search);
    params.delete('page');
    params.set('section_id', grid.getAttribute('data-id'));
    var jobs = [];
    for (var n = 1; n <= pages; n++) {
      if (n === page) continue;
      jobs.push((function (n) {
        var p = new URLSearchParams(params);
        p.set('page', n);
        return fetch(location.pathname + '?' + p.toString())
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var g = new DOMParser().parseFromString(html, 'text/html').getElementById('main-collection-product-grid');
            if (!g) return [];
            /* same as the theme does after its own AJAX filtering (component-facets.js) */
            g.querySelectorAll('template').forEach(function (t) {
              var form = t.closest('form');
              if (form) form.append(t.content.cloneNode(true));
            });
            return readGrid(g, n);
          })
          .catch(function () { return []; });
      })(n));
    }
    grid.style.opacity = '.5';
    loading = Promise.all(jobs).then(function (lists) {
      gridAtStart.style.opacity = '';
      if (grid !== gridAtStart) return;   /* the theme re-rendered the grid meanwhile */
      extra = [].concat.apply([], lists);
      loaded = true;
      loading = null;
    });
    return loading;
  }

  function all() {
    return extra ? items.concat(extra).sort(function (a, b) { return a.page - b.page; }) : items;
  }

  /* ---------- state ---------- */

  var sel = { cat: [], pack: [], brand: [], feat: [] };
  var KEY = 'snCollFilters:' + location.pathname;

  function query() { return input ? norm(input.value) : ''; }
  function anySel() { return GROUPS.some(function (g) { return sel[g.id].length > 0; }); }
  function fits(r, skip, q) {
    if (q && r.title.indexOf(q) === -1) return false;
    return GROUPS.every(function (g) {
      if (g.id === skip || !sel[g.id].length) return true;
      return r.v[g.id].some(function (k) { return sel[g.id].indexOf(k) !== -1; });
    });
  }

  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(sel)); } catch (e) {}
  }
  /* only when the customer comes back with the back button, not on a fresh visit */
  function restore() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (!nav || nav.type !== 'back_forward') return sessionStorage.removeItem(KEY);
      var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (s) GROUPS.forEach(function (g) { if (Array.isArray(s[g.id])) sel[g.id] = s[g.id]; });
    } catch (e) {}
  }

  function clearAll() {
    GROUPS.forEach(function (g) { sel[g.id] = []; });
    if (input) input.value = '';
    save();
  }

  /* ---------- output ---------- */

  function emptyBox() {
    var box = document.getElementById('SnCollEmpty');
    if (!box) {
      box = document.createElement('div');
      box.id = 'SnCollEmpty';
      box.className = 'sn-coll-empty';
      box.innerHTML = '<strong>' + esc(T.none) + '</strong><span></span><br><button type="button">' + esc(T.clear) + '</button>';
      box.querySelector('button').addEventListener('click', function () {
        clearAll();
        update();
      });
    }
    if (box.nextElementSibling !== grid) grid.parentNode.insertBefore(box, grid);
    return box;
  }

  function renderGroups() {
    if (!hosts.length) return;
    var list = loaded ? all() : items;
    var q = query();
    var html = GROUPS.map(function (g) {
      var counts = {};
      var keys = [];
      list.forEach(function (r) {
        var ok = fits(r, g.id, q);
        r.v[g.id].forEach(function (k) {
          if (!(k in counts)) { counts[k] = 0; keys.push(k); }
          if (ok) counts[k]++;
        });
      });
      sel[g.id].forEach(function (k) { if (!(k in counts)) { counts[k] = 0; keys.push(k); } });
      /* only choices that give products with what is already chosen */
      keys = keys.filter(function (k) { return counts[k] > 0 || sel[g.id].indexOf(k) !== -1; });
      if (keys.length < 2 && !sel[g.id].length) return '';

      var label = function (k) { return info[g.id][k] ? info[g.id][k].label : k; };
      keys.sort(function (a, b) {
        if (g.id === 'brand') return label(a).localeCompare(label(b), 'tr');
        var sa = info[g.id][a] ? info[g.id][a].sort : 1e9;
        var sb = info[g.id][b] ? info[g.id][b].sort : 1e9;
        return sa - sb || label(a).localeCompare(label(b), 'tr');
      });

      var hidden = 0;
      var rows = keys.map(function (k, i) {
        var on = sel[g.id].indexOf(k) !== -1;
        var off = !on && !counts[k];
        var extraRow = i >= 6 && !on;
        if (extraRow) hidden++;
        return '<li class="list-menu__item facets__item' + (extraRow ? ' sn-facet-extra' : '') + '">' +
          '<label class="facet-checkbox' + (off ? ' facet-checkbox--disabled' : '') + '">' +
          '<input type="checkbox" class="styled-checkbox" data-sn-value="' + esc(k) + '"' + (on ? ' checked' : '') + (off ? ' disabled' : '') + '>' +
          esc(label(k)) + ' (' + counts[k] + ')</label></li>';
      }).join('');

      return '<details class="disclosure-has-popup facets__disclosure sn-cf-group" data-sn-group="' + g.id + '">' +
        '<summary class="facets__summary"><span class="facets__summary-text">' + esc(g.label) + '</span></summary>' +
        '<div class="facets__display body-text-sm"><ul class="facets__list list-unstyled" role="list">' + rows + '</ul>' +
        (hidden ? '<button type="button" class="sn-facets-more" aria-expanded="false">' +
          '<span class="sn-facets-more__show">' + esc(T.more) + ' (+' + hidden + ')</span>' +
          '<span class="sn-facets-more__hide">' + esc(T.less) + '</span></button>' : '') +
        '</div></details>';
    }).join('');

    hosts.forEach(function (host) {
      /* keep what the customer opened */
      var open = {};
      var more = {};
      host.querySelectorAll('[data-sn-group]').forEach(function (d) {
        var id = d.getAttribute('data-sn-group');
        open[id] = d.open;
        more[id] = !!d.querySelector('.facets__list.is-expanded');
      });
      host.innerHTML = html;
      host.querySelectorAll('[data-sn-group]').forEach(function (d) {
        var id = d.getAttribute('data-sn-group');
        if (open[id] || (open[id] === undefined && sel[id].length)) d.open = true;
        if (more[id]) {
          d.querySelector('.facets__list').classList.add('is-expanded');
          var btn = d.querySelector('.sn-facets-more');
          if (btn) btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* chosen values as chips next to the theme's own ones above the products */
  function renderChips() {
    var row = document.querySelector('#CollectionProductGrid .active-facets');
    if (!row) return;
    row.querySelectorAll('[data-sn-chip], [data-sn-chip-clear]').forEach(function (a) { a.remove(); });
    var themeClear = row.querySelector('.button--solid');
    var chips = '';
    GROUPS.forEach(function (g) {
      sel[g.id].forEach(function (k) {
        var i = info[g.id][k];
        chips += '<a href="#" class="active-facets__button active-facets__button--light button button--small button--outline" data-sn-chip="' +
          g.id + '" data-sn-key="' + esc(k) + '">' + esc(i ? i.label : k) + '&nbsp;&times;</a>';
      });
    });
    if (!chips) return;
    if (!themeClear) chips += '<a href="#" class="active-facets__button button button--small button--solid" data-sn-chip-clear>' + esc(T.clearAll) + '</a>';
    if (themeClear) themeClear.insertAdjacentHTML('beforebegin', chips);
    else row.insertAdjacentHTML('beforeend', chips);
  }

  function update() {
    var q = query();
    var active = !!q || anySel();
    if (active && !loaded) {
      renderGroups();
      loadAll().then(update);
      return;
    }

    /* the cards of the other pages are in the grid only while something is chosen */
    if (active !== expanded) {
      expanded = active;
      if (active) {
        all().forEach(function (r) { grid.insertBefore(r.el, pager); });
      } else if (extra) {
        extra.forEach(function (r) { if (r.el.parentNode) r.el.parentNode.removeChild(r.el); });
      }
      if (pager) pager.style.display = active ? 'none' : '';
    }

    var shown = 0;
    (active ? all() : items).forEach(function (r) {
      var ok = !active || fits(r, null, q);
      var display = ok ? '' : 'none';
      if (r.el.style.display !== display) r.el.style.display = display;
      if (ok) shown++;
    });

    var count = document.getElementById('CollectionProductCount');
    if (count) {
      if (!count.hasAttribute('data-sn-orig')) count.setAttribute('data-sn-orig', count.innerHTML);
      if (active) count.textContent = T.found.replace('{n}', shown);
      else count.innerHTML = count.getAttribute('data-sn-orig');
    }

    var box = emptyBox();
    box.classList.toggle('is-visible', active && shown === 0);
    box.querySelector('span').textContent = active && shown === 0
      ? (q ? T.noneSearch.replace('{q}', input.value.trim()) : T.noneFilter)
      : '';

    renderGroups();
    renderChips();
    save();
  }

  /* ---------- events ---------- */

  if (!init()) return;
  restore();

  hosts.forEach(function (host) {
    host.addEventListener('change', function (e) {
      var box = e.target.closest('input[data-sn-value]');
      if (!box) return;
      var g = box.closest('[data-sn-group]').getAttribute('data-sn-group');
      var k = box.getAttribute('data-sn-value');
      sel[g] = sel[g].filter(function (x) { return x !== k; });
      if (box.checked) sel[g].push(k);
      update();
    });
    host.addEventListener('click', function (e) {
      var btn = e.target.closest('.sn-facets-more');
      if (!btn) return;
      var list = btn.previousElementSibling;
      list.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', list.classList.contains('is-expanded'));
    });
    /* on a collection with several pages, the groups get the values of all pages
       as soon as the customer starts using the filters */
    var complete = function () {
      if (!loaded) loadAll().then(renderGroups);
    };
    host.addEventListener('toggle', complete, true);
    host.addEventListener('pointerenter', complete);
    host.addEventListener('focusin', complete);
  });

  if (input) input.addEventListener('input', update);

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-sn-chip]');
    if (chip) {
      e.preventDefault();
      var g = chip.getAttribute('data-sn-chip');
      var k = chip.getAttribute('data-sn-key');
      sel[g] = sel[g].filter(function (x) { return x !== k; });
      update();
      return;
    }
    if (e.target.closest('[data-sn-chip-clear]')) {
      e.preventDefault();
      clearAll();
      update();
      return;
    }
    /* the theme's own "clear all" links also clear these filters */
    var link = e.target.closest('a[href]');
    if (link && link.getAttribute('href') === cfg.url && link.closest('.active-facets, #site-filters-sidebar')) clearAll();
  });

  /* the theme re-renders the grid after "Stok durumu" / "Fiyat" / sorting in the drawer */
  document.addEventListener('krown:main-collection-grid:filtered', function () {
    if (init()) update();
  });

  update();
})();
